import styled from "styled-components";

export const LoginPhoneInitialStepStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 88vh;
`;
export const DriverBoxStyled = styled.div`
  padding: 10px;
  border-radius: 18px;
  opacity: 0.6;
  /* border: solid 1px #2a2e43; */
  /* background-color: #fff; */
  margin: 30px 0;
`;
export const UserBoxStyled = styled.div`
  padding: 12px;
  border-radius: 18px;
  border: solid 1px #ffbf1d;
  background-color: #fff;
  /* margin: 30px 0; */
`;
export const UserBoxBtnStyled = styled.div`
  padding: 3px 6px;
  border-radius: 10px;
  background-color: #ffbf1d;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 65%;
  color: #fff;
  cursor: pointer;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 16px;
`;
export const LogoContainerStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;
export const TitleStyled = styled.div`
  font-size: 16px;
  font-weight: 999;
  margin: 6px 0;
`;
export const TextStyled = styled.div`
  font-size: 11px;
  margin: 5px 0 20px 0;
  white-space: nowrap;
`;
export const BtnConrainerStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
export const UserWelcomeStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 100px; 
`;
